import axios from 'axios';
import { BASE_URL, CHARGE, GETWAY, TRANSACTION, WALLET } from './endpoints';

const WALLET_BASE_URL = `${BASE_URL}${WALLET.BASE}`;

const WALLET_TRANSACTION_FROM_REFID = `${BASE_URL}${WALLET.TRANSACTION_LIST_FROM_REF_ID}`;

export const fetchWalletTransactionFromRefId = (data: any) => {
    return axios.get(WALLET_TRANSACTION_FROM_REFID + '?transactionReferenceId' + '=' + data.refId);
};